import React from 'react';

// Parents
import StudentsTabs from './dash-students-tabs';
import StudentsRoutes from './dash-students-routes';

export default function (props) {

  return (
    <StudentsTabs>
      <StudentsRoutes />
    </StudentsTabs>
  )
}
